module.exports = __webpack_public_path__ + "static/media/bandeira-euro.833a5f5e.png";